export default __webpack_public_path__ + "static/media/Group1748.a02f3c9f.png";